export default __webpack_public_path__ + "static/media/ic_aruba.386d16dd.svg";